<script>
  import mixin from "../mixin";

  export default {
    name: "PartnerApproved",
    mixins: [mixin],
  };
</script>

<template>
  <p class="p-base-medium text-neutral-400 m-b-9">
    {{ $t(`notifications.${notification.type}`) }}
  </p>
</template>

<style lang="sass" scoped>
</style>
